import { defineComponent as _defineComponent } from 'vue'
import {AlertType} from '@/models/enums/AlertType';
import {computed, PropType} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertMessage',
  props: {
  alertType: {
    type: String as PropType<AlertType>,
    default: AlertType.WARNING,
  },
},
  setup(__props) {

const props = __props


const icon = computed<string>(() => {
  switch (props.alertType) {
  case AlertType.WARNING:
    return 'mdi-alert';
  case AlertType.INFO:
    return 'mdi-information';
  case AlertType.SUCCESS:
    return 'mdi-check';
  case AlertType.ERROR:
    return 'mdi-alert-octagon';
  default:
    return 'mdi-alert';
  }
});

return { __sfc: true,props, icon }
}

})